"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeLinePriceFromFee = computeLinePriceFromFee;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const big_js_1 = __importDefault(require("big.js"));
const compute_total_quantity_1 = require("../compute-total-quantity");
const compute_total_weight_1 = require("../compute-total-weight");
function computeLinePriceFromFee(fee, price, lines) {
    if (!fee)
        return lines.map(line => ({ lineId: line.lineId, retrocessionPrice: '0' }));
    const total = isFeeSpreadQuantity(fee) ? (0, compute_total_quantity_1.computeTotalQuantity)(lines) : (0, compute_total_weight_1.computeTotalWeight)(lines);
    return lines.map(line => ({
        lineId: line.lineId,
        retrocessionPrice: (0, big_js_1.default)(isFeeSpreadQuantity(fee) ? (0, compute_total_quantity_1.computeTotalQuantity)([line]) : (0, compute_total_weight_1.computeTotalWeight)([line]))
            .times(price)
            .div(total)
            .toString()
    }));
}
function isFeeSpreadQuantity(fee) {
    return fee.feesSpread === module_logistic_interfaces_1.FeesSpreadUnit.Quantity;
}
